<template>
  <div class="modal-box" v-if="show">
    <div class="modal-content">
      <div class="bg">
        <div class="title">请输入正确的专区口令</div>
        <div>
          <input
            type="text"
            v-model.trim="code"
            class="code-input"
            placeholder="请输入专区口令"
            @input="inputChange"
          />
        </div>
        <div class="err-text" v-if="errShow && code.length">专区口令有误</div>
        <div>
          <button class="btn btn-s1" @click.stop="modalClose">取消</button>
          <button class="btn btn-s2" @click.stop="submitCode">确定</button>
        </div>
      </div>
      <div class="close-box">
        <a-icon
          type="close-circle"
          class="icon-close"
          @click.stop="modalClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // 专区活动ID
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 口令
      code: '',
      // 口令错误显示
      errShow: false,
    }
  },
  methods: {
    inputChange() {
      if (this.errShow) {
        this.errShow = false
      }
    },
    // 点击关闭或者取消
    modalClose() {
      this.$emit('close')
    },
    // 确定专区口令
    async submitCode() {
      if (this.code) {
        let res = await this.postAction(
          '/api_promotions/SalesPromotion/ActivityVerificationPwd',
          {
            Id: this.id,
            CommandCode: this.code,
          }
        )
        if (!res.Data) {
          this.errShow = true
        } else {
          this.$emit('ok', this.code)
        }
      } else {
        this.$toast({
          message: '请输入专区口令',
          // position: 'top'
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
.modal-box {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
}
.close-box {
  color: #fff;
  margin-top: 20px;
}
.icon-close {
  cursor: pointer;
  font-size: 30px;
}
.bg {
  width: 350px;
  background: url('../assets/code-modal.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 22px 20px;
}
.err-text {
  font-size: 12px;
  color: red;
  padding: 10px;
}
.modal-content {
  .title {
    color: #fff;
    font-size: 16px;
    text-align: center;
  }
  .code-input {
    width: 100%;
    height: 91px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px #7fabff;
    border-radius: 12px;
    border: 0;
    margin-top: 16px;
    text-align: center;
    box-sizing: border-box;
    padding: 15px;
    color: #111a34;
    font-size: 14px;
  }
  .btn {
    width: 145px;
    height: 40px;
    background: linear-gradient(180deg, #ffec32 0%, #ffd417 100%);
    border-radius: 22px;
    color: #111a34;
    cursor: pointer;
    border: 0;
    margin-top: 12px;
    font-size: 16px;
  }
  .btn-s1 {
    background: #81b7ff;
    margin-right: 10px;
  }
  .btn-s2 {
    background: linear-gradient(180deg, #ffec32 0%, #ffd417 100%);
    margin-left: 10px;
  }
}
</style>
